var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile && _vm.isRunningEventEnd())?_c('Banner'):_vm._e(),(_vm.isOpenPopup)?_c('HomePopup',{attrs:{"isMobile":_vm.isMobile}}):_vm._e(),_c('HomeExpansionPanels'),_c('Activity',{attrs:{"isShowMore":true}}),_c('Footer',{attrs:{"socialMedia":_vm.socialMedia}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }